import moment from 'moment';
import { getUtilityIconType } from 'src/pages/NewBillingModule/ApplyBillingFull/BillAutomationExtraction/BillAutomationExtractedSummary';
import { getExtractedTotalAmount } from 'src/pages/NewBillingModule/ApplyBillingFull/BillAutomationExtraction/billAutomationExtractionUtils';
import { BILL_AUTOMATION_STATUS } from 'src/stores/billAutomation/uploadedBills';
import { getUtilityLabel } from './billsFilters';
import { BILL_SOURCES } from './subscriptionsTabDemoData';
const DASH = '—';
const TABLE_DATE_FORMAT = 'DD/MM/YY';
const ROW_STATUS_BY_BILL_STATUS = {
  [BILL_AUTOMATION_STATUS.processing]: 'Pending',
  [BILL_AUTOMATION_STATUS.extracted]: 'Extracted',
  [BILL_AUTOMATION_STATUS.validated]: 'Validated',
  [BILL_AUTOMATION_STATUS.failed]: 'Failed'
};
const formatTableDate = value => {
  if (!value) return DASH;
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format(TABLE_DATE_FORMAT) : DASH;
};
const getExtractedServiceTypes = data => {
  const serviceTypes = new Set();
  ((data === null || data === void 0 ? void 0 : data.properties) || []).forEach(property => {
    (property.services || []).forEach(service => {
      if (service !== null && service !== void 0 && service.serviceType) serviceTypes.add(service.serviceType);
    });
  });
  return [...serviceTypes];
};

/** Maps a session-uploaded bill onto the same row shape the demo rows use. */
export const mapUploadedBillToRow = bill => {
  // Edits made in the details view are what the row should report.
  const data = bill.effectiveData || null;
  const extractedServiceTypes = getExtractedServiceTypes(data);
  const utilityTypes = extractedServiceTypes.length ? extractedServiceTypes : [...(bill.requestedUtilityTypes || [])];
  const utilityIcons = [...new Set(utilityTypes.map(getUtilityIconType))];
  const extractedAddresses = ((data === null || data === void 0 ? void 0 : data.properties) || []).map(property => property.address).filter(Boolean);
  const propertiesLines = extractedAddresses.length ? extractedAddresses : [bill.propertyAddress].filter(Boolean);
  const serviceStart = data !== null && data !== void 0 && data.serviceStartDate ? moment(data.serviceStartDate) : null;
  const serviceEnd = data !== null && data !== void 0 && data.serviceEndDate ? moment(data.serviceEndDate) : null;
  const hasServicePeriod = (serviceStart === null || serviceStart === void 0 ? void 0 : serviceStart.isValid()) && (serviceEnd === null || serviceEnd === void 0 ? void 0 : serviceEnd.isValid());
  const amount = getExtractedTotalAmount(data);
  const utilitiesToAllocate = utilityTypes.length || 1;
  const days = hasServicePeriod ? Math.max(serviceEnd.clone().startOf('day').diff(serviceStart.clone().startOf('day'), 'days') + 1, 1) : DASH;
  const allocationTotal = ((data === null || data === void 0 ? void 0 : data.properties) || []).reduce((acc, property) => acc + (property.services || []).length, 0) || utilitiesToAllocate;
  const allocationsApproved = Math.min((bill.approvedAllocations || []).length, allocationTotal);
  return {
    id: bill.billId,
    /** Only these rows have a bill behind them, so only they open the details view. */
    isUploaded: true,
    fileName: bill.fileName || DASH,
    status: ROW_STATUS_BY_BILL_STATUS[bill.status] || 'Pending',
    // The chip collapses Extracted and Validated, so the hover text keeps the real state visible.
    statusTooltip: [bill.status, ...(bill.errors || [])].filter(Boolean).join(' — '),
    // These rows are always uploaded from this page.
    billSource: BILL_SOURCES.billsDashboard,
    allocation: {
      done: allocationsApproved,
      total: allocationTotal
    },
    // Pushing covers the whole bill, so the column is all or nothing.
    appfolioPush: {
      done: bill.isPushedToAppfolio ? utilitiesToAllocate : 0,
      total: utilitiesToAllocate
    },
    utilityIcons,
    utilityTypes: utilityIcons.map(getUtilityLabel),
    propertiesLines,
    account: (data === null || data === void 0 ? void 0 : data.accountNumber) || DASH,
    provider: (data === null || data === void 0 ? void 0 : data.vendorName) || DASH,
    servicePeriod: hasServicePeriod ? "".concat(serviceStart.format(TABLE_DATE_FORMAT), " - ").concat(serviceEnd.format(TABLE_DATE_FORMAT)) : DASH,
    days,
    amount: typeof amount === 'number' ? amount : null,
    // The extraction payload carries no invoice number yet.
    invoiceNumber: DASH,
    dueDate: formatTableDate(data === null || data === void 0 ? void 0 : data.dueDate),
    dateUploaded: formatTableDate(bill.uploadedAt)
  };
};